module.exports = "/_next/static/images/my_bank-ee3a15288b6a1dc25b9fb85c7546e40c.png";